import React, { useEffect, useState } from 'react';
import api from '../../lib/api';

export const HEALTH_CONSENT_TEXT =
  'I agree that OVERALL WELLBEING may store the health information I enter, such as health metrics or medication records, only to show it back to me in my personal space. It is never shared, sold or used for analytics. I can delete it at any time.';

// Tracks (and grants) the separate consent required before any health data is saved.
export function useHealthConsent() {
  const [granted, setGranted] = useState(null); // null = unknown
  const [ticked, setTicked] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get('/me/health-consent');
        if (active) setGranted(!!data.granted);
      } catch { if (active) setGranted(false); }
    })();
    return () => { active = false; };
  }, []);

  const ensure = async () => {
    if (granted) return true;
    if (!ticked) return false;
    await api.post('/me/health-consent');
    setGranted(true);
    return true;
  };

  return { granted, ticked, setTicked, ensure, blocked: granted === false && !ticked };
}

export const HealthConsentCheck = ({ granted, ticked, setTicked }) => {
  if (granted !== false) return null;
  return (
    <label
      htmlFor="health-consent-check"
      data-testid="health-consent-check-wrap"
      className="mt-space-md flex items-start gap-space-sm p-space-md rounded-lg bg-primary-container border-l-4 border-surface-tint cursor-pointer"
    >
      <input
        id="health-consent-check"
        data-testid="health-consent-checkbox"
        type="checkbox"
        checked={ticked}
        onChange={(e) => setTicked(e.target.checked)}
        className="mt-1 w-4 h-4 accent-[#F028DF] shrink-0"
      />
      <span className="font-body-md text-body-md text-on-surface-variant leading-relaxed">{HEALTH_CONSENT_TEXT}</span>
    </label>
  );
};

export default HealthConsentCheck;
